import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggingService, PinItCoreModule } from '@pit/core';

@NgModule({
    imports: [
        CommonModule,

        PinItCoreModule
    ],
})
export class PinItTrackFrontendModelModule {

    constructor(loggingService: LoggingService) {
        loggingService.debug('PinItTrackFrontendModelModule --> constructor()');

    }

    public static forRoot(): ModuleWithProviders<PinItTrackFrontendModelModule> {
        return {
            ngModule: PinItTrackFrontendModelModule,
            providers: []
        };
    }

}
